import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { ConfigApi } from "../../config-api";
import { ApiCallingService } from "../../services/api-calling.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-vending-shipping-feature",
  templateUrl: "./vending-shipping-feature.component.html",
  styleUrls: ["./vending-shipping-feature.component.css"],
})
export class VendingShippingFeatureComponent implements OnInit {
  shippingData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  loading: boolean = false;
  userDetails: any;
  modeltitle: any;
  detail: any = {};
  shippingToDelete: string = "";
  shippingForm: FormGroup = new FormGroup({});
  storeList: any[] = [];
  allcountry: any[] = [];
  submitting: boolean = false;

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private http: HttpClient
  ) {
    let data = localStorage.getItem("Auth-user");
    if (!data) {
      return;
    }
    try {
      this.userDetails = JSON.parse(data);
    } catch (error) {
      console.error(error);
    }
  }

  ngOnInit(): void {
    this.initForm();
    this.getShippingList();
    this.getStoreList();
    this.getCountries();
  }

  initForm() {
    this.shippingForm = this.fb.group({
      serviceName: ["", Validators.required],
      country_iso_code: ["", Validators.required],
      price: [null, [Validators.required, Validators.min(0)]],
      vat: [null, [Validators.required, Validators.min(0)]],
      isExclusive: [false],
    });
  }

  getCountries() {
    this.http.get("assets/countries.json").subscribe((data: any) => {
      this.allcountry = data;
    });
  }

  getStoreList() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.VENDING_CATEGORY.PickupLocationList +
          "?operator_id=" +
          this.userDetails._id
      )
      .subscribe((res: any) => {
        if (res.success) {
          this.storeList = res.data;
        }
      });
  }

  onSubmit() {
    if (this.shippingForm.invalid) {
      this.shippingForm.markAllAsTouched();
      return;
    }

    this.submitting = true;
    const payload = {
      ...this.shippingForm.value,
      operator_id: this.userDetails._id,
    };

    let url = ConfigApi.URLS.VENDING_SHIPPING_FEATURE.CREATE;
    let method = "POST";

    if (this.modeltitle === "Edit Shipping") {
      url =
        ConfigApi.URLS.VENDING_SHIPPING_FEATURE.UPDATE + "/" + this.detail._id;
      method = "PUT";
    }

    this.apiCallingService.callAPI(payload, method, url).subscribe(
      (res: any) => {
        this.submitting = false;
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success(res.msg || "Shipping saved successfully");
          this.modalService.dismissAll();
          this.getShippingList();
        }
      },
      (err) => {
        this.submitting = false;
        this.toastr.error(err.error.msg || "Something went wrong");
      }
    );
  }

  getShippingList() {
    this.loading = true;
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.VENDING_SHIPPING_FEATURE.LIST +
          `?operator_id=${this.userDetails._id}&page=${this.page - 1}&limit=${
            this.pageSize
          }`
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.shippingData = res.data || [];
            this.totalCount = res.total || 0;
          }
          this.loading = false;
        },
        (error) => {
          console.error(error);
          this.toastr.error("Failed to load shipping");
          this.loading = false;
        }
      );
  }

  openModal(targetModal: any, data: any, title: any) {
    this.modeltitle = title;
    this.detail = Object.assign({}, data);
    if (this.modeltitle === "Edit Shipping") {
      const countryCode =
        data.country_iso_code || data.countryObject?.iso || data.country?.iso;

      this.shippingForm.patchValue({
        serviceName: data.serviceName,
        country_iso_code: countryCode ? countryCode.toUpperCase() : "",
        price: data.price,
        vat: data.vat,
        isExclusive: data.isExclusive,
      });
    } else {
      this.shippingForm.reset({
        isExclusive: false,
        price: null,
        vat: null,
      });
    }

    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
      size: "lg",
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.getShippingList();
  }

  openDeleteModal(content: any, id: any) {
    this.shippingToDelete = id;
    this.modalService.open(content, { centered: true });
  }

  confirmDelete() {
    this.apiCallingService
      .callAPI(
        {},
        "DELETE",
        ConfigApi.URLS.VENDING_SHIPPING_FEATURE.DELETE +
          "/" +
          this.shippingToDelete
      )
      .subscribe((res: any) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success(res.msg || "Shipping deleted successfully");
          this.modalService.dismissAll();
          this.getShippingList();
        }
      });
  }
}
